import JudgingHome from './JudgingHome';

export default JudgingHome;
